export function computeLabel(f) {
	if (f?.value != null) return `${f.value}${f.unit || ""}`;
	if (f?.length != null && f?.width != null && f?.height != null)
		return `${f.length}×${f.width}×${f.height}${f.unit || ""}`;
	if (f?.length != null && f?.width != null) return `${f.length}×${f.width}${f.unit || ""}`;
	return f?.format || f?.label || "";
}

function tryKeys(t, keys, fallback) {
	for (const k of keys) {
		let out;
		try {
			out = t(k);
		} catch {
			out = undefined;
		}
		if (out && out !== k) return out;
	}
	return fallback ?? keys[0];
}

export function localizeLabel(s, t) {
	const str = String(s || "");
	const L = tryKeys(t, ["length"], "length");
	const W = tryKeys(t, ["width"], "width");
	const H = tryKeys(t, ["height"], "height");
	const V = tryKeys(t, ["value"], "value");
	return str
		.replace(/\blength\b/gi, L)
		.replace(/\bwidth\b/gi, W)
		.replace(/\bheight\b/gi, H)
		.replace(/\bvalue\b/gi, V);
}

export function buildOptionText(opt, t) {
	const base = computeLabel(opt);
	const localized = localizeLabel(base, t);
	if (/^\d+(\.\d+)?$/.test(localized) && opt?.outUnit) {
		return `${localized} ${opt.outUnit}`;
	}
	return localized;
}
